
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 90 57.72"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45 39.22a10.36 10.36 0 1110.52-10.36A10.45 10.45 0 0145 39.22zm0-27.38a17 17 0 1017.18 17 17.13 17.13 0 00-17.18-17zm0 39.22c-21.15 0-37.82-18.44-38.34-22.12C7.18 25.14 23.85 6.67 45 6.67s37.82 18.47 38.34 22.11C82.82 32.62 66.15 51.06 45 51.06zM45 0C20.44 0 0 21 0 28.86s20.44 28.86 45 28.86 45-20.95 45-28.86S69.56 0 45 0z","fill":"#7e7e7e"}})])
          )
        }
      }
    